import { Typography } from '@mui/material';
import { grey } from '@mui/material/colors';

export const SiteInfoContainer = ({
  children,
  isSidebarOpen,
}: React.PropsWithChildren<unknown> & { isSidebarOpen: boolean }) => {
  return (
    <Typography
      component={'div'}
      style={{
        color: grey['400'],
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: '.5rem',
        marginLeft: '2rem',
        marginRight: '2rem',
        marginTop: '1rem',
        textAlign: 'center',
      }}
      variant="body2"
    >
      {isSidebarOpen ? children : <span>&nbsp;</span>}
    </Typography>
  );
};
